import axios from 'axios';

export { apiError } from '@/api/auction';

const ax = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/account`, withCredentials: true });

export const accountRegister = (data) => ax.post('/register', data).then((r) => r.data);
export const accountLogin = (data) => ax.post('/login', data).then((r) => r.data);
export const accountLogout = () => ax.post('/logout').then((r) => r.data);
export const accountMe = () => ax.get('/me').then((r) => r.data);
export const googleSession = (sessionId) => ax.post('/google/session', {}, { headers: { 'X-Session-ID': sessionId } }).then((r) => r.data);
export const updateProfile = (data) => ax.patch('/profile', data).then((r) => r.data);
export const changePassword = (data) => ax.post('/change-password', data).then((r) => r.data);
export const forgotPassword = (email) => ax.post('/forgot-password', { email }).then((r) => r.data);
export const resetPassword = (token, password) => ax.post('/reset-password', { token, password }).then((r) => r.data);

// UAE PASS
export const uaepassStart = (params) => ax.get('/uaepass/start', { params }).then((r) => r.data);
export const uaepassTicket = (ticket) => ax.get(`/uaepass/ticket/${ticket}`).then((r) => r.data);
export const uaepassLinkExisting = (data) => ax.post('/uaepass/link-existing', data).then((r) => r.data);
export const uaepassRegister = (data) => ax.post('/uaepass/register', data).then((r) => r.data);
export const uaepassUnlink = () => ax.post('/uaepass/unlink').then((r) => r.data);

// My documents
export const listDocuments = () => ax.get('/documents').then((r) => r.data);
export const uploadDocument = (formData) => ax.post('/documents', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
export const deleteDocument = (id) => ax.delete(`/documents/${id}`).then((r) => r.data);
export const documentUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/account/documents/${id}/file`;

export const ACCOUNT_TYPE_LABEL = { retail: 'Personal · Retail', corporate: 'Corporate · Business' };
export const STATUS_LABEL = { active: 'Active', pending: 'Awaiting approval', rejected: 'Not approved' };
export const BRAND_ACCOUNT = 'Eurogulf 360 Mobility';
